import axios from 'axios';
import { DOMAIN, API_V1 } from '@/common/agent/ApiAgent';

const URL_PATH_LOGOUT = '/users/logout';

export type LogoutResponseData = {
  message: string;
};

const logout = () => {
  return axios.post<LogoutResponseData>(
    DOMAIN + API_V1 + URL_PATH_LOGOUT,
    undefined,
    { withCredentials: true },
  );
};

export default logout;
